import PropTypes from "prop-types";

const stepProps = {
  nextStep: PropTypes.func,
  previousStep: PropTypes.func,
  goToStep: PropTypes.func,
  initialOs: PropTypes.string,
};
export default stepProps;
